import AuthWrapper from '../../components/auth/AuthWrapper';
import LoginForm from '../../components/auth/LoginForm';

export default function Login() {
  return(
    <AuthWrapper>
      <LoginForm />
    </AuthWrapper>  
  )
}